import React, { useState, useEffect} from "react";
import { Image, Empty } from "antd";
import { BarsOutlined } from "@ant-design/icons";

const FileDetail = ({
  urlKey = 'baseUrl',
  nameKey = 'name',
  fileList,
  customConfig,
}) => {
  const [pdfUrl, setPdfUrl] = useState('');
  const [imgUrl, setImgUrl] = useState('');
  const [imgVisible, setImgVisible] = useState(false);
  const [imgList, setImgList] = useState([]);
  const [pdfList, setPdfList] = useState([]);

  const filterFileListFn = (list = [], flag) => {
    const acceptList = ["jpg", "png", "jpeg", "gif", "bmp", "webp", "svg", "ico", "tif", "tiff"]
    return list.filter(item => {
      const str = item[nameKey]?.split('?')?.[0]?.split('.')?.pop()?.toLowerCase()
      return flag ? acceptList.includes(str) : !acceptList.includes(str)
    })
  }

  const getImgPdfFn = (fileList) => {
    setImgList(filterFileListFn(fileList, true))
    setPdfList(pre => {
      const list = filterFileListFn(fileList, false)
      if(!list.length){
        setPdfUrl('')
      } else if (!pdfUrl || list.every(item => item[urlKey] !== pdfUrl)) {
        setPdfUrl(list[0][urlKey]);
      }
      return list
    })
  }

  const initFn = () => {
    setImgUrl('')
    setPdfUrl('')
    setImgVisible(false)
    setImgList([])
    setPdfList([])
  }

  useEffect(()=>{
    if(!fileList.length){
      initFn();
    }else{
      getImgPdfFn(fileList)
    }
  },[fileList])

  return (
    <>
      {imgList.length && (
        <>
          {imgList.map((item) => (
            <div style={{ display: 'inline-block', margin: '10px 10px 0 0'}}>
              <Image
                width={100}
                height={100}
                src={item[urlKey]}
                alt={item[nameKey]}
              />
            </div>
            ))
          }
        </>
      ) || null}

      {imgUrl && (
        <Image
          wrapperStyle={{
            display: 'none',
          }}
          preview={{
            visible: imgVisible,
            onVisibleChange: (visible) => setImgVisible(visible),
            afterOpenChange: (visible) => !visible && setImgUrl(''),
          }}
          src={imgUrl}
        />
      )}

      {pdfList.length && (
        <div className="mainName">
          {pdfList.map((item, index) => (
              <a
                style={{width: '100%', color: pdfUrl === item[urlKey] && '#000'}}
                key={index}
                onClick={() => setPdfUrl(item[urlKey])}
              >
                <BarsOutlined /> {item[nameKey]}
              </a>
            ))
          }
        </div>
      ) || null}

      {pdfUrl && (
        <div className="PDFbox">
          <iframe
            src={`${pdfUrl}${customConfig?.pdfUrlArg || ''}`}
            title="PDF Viewer"
            width="100%"
            style={{ height: customConfig?.pdfHeight || "50vh" }}
          />
        </div>
      )}

      {(!imgList.length && !pdfList.length) && (
        <Empty description="No data available" />
      )|| null}
    </>
  );
};

export default FileDetail;